import React from 'react';

import type { FC } from 'react';

export const Close: FC<React.SVGAttributes<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" {...props}>
      <path d="M11.0827 3.73913L10.2602 2.91663L6.99935 6.17746L3.73852 2.91663L2.91602 3.73913L6.17685 6.99996L2.91602 10.2608L3.73852 11.0833L6.99935 7.82246L10.2602 11.0833L11.0827 10.2608L7.82185 6.99996L11.0827 3.73913Z" />
    </svg>
  );
};
